import React from "react"
import { Card, CardBody, Spinner } from "reactstrap"


export const LoadingIndicator = () => {
  return (
    <Card>
      <CardBody className={"p-2 text-center"}>
        <Spinner className="ms-2" color="primary"/>
      </CardBody>
    </Card>
  )
}

export const InlineLoadingIndicator = () => {
  return (
    <Spinner className="ms-2" size="sm" color="primary"/>
  )
}